import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpRegionalDistributionKeys = {
  all: ['analytics', 'fp-regional-distribution'] as const,
  list: (params?: AnalyticsQueryParams) =>
    [...fpRegionalDistributionKeys.all, 'list', params] as const,
};

export const useFPRegionalDistributionData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpRegionalDistributionKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPRegionalDistribution(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
